/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import {
  Box,
  Input /* The above code is a comment in JavaScript. It is not doing anything in terms of
functionality, but it is used to provide information or explanations about the
code to other developers. */,
  Typography,
} from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import Footer from "./footer";
import Dropdown from "./dropdown";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const taxAuthoritiesOption = [
  {
    value: "Cục thuế TP.HCM",
    label: "Cục thuế TP.HCM",
  },
  {
    value: "Cục thuế An giang",
    label: "Cục thuế An giang",
  },
  {
    value: "Cục thuế Cần thơ",
    label: "Cục thuế Cần thơ",
  },
  {
    value: "Cục thuế Hà nội",
    label: "Cục thuế Hà nội",
  },
];

const partOption = [
  {
    value: "Thuế thu nhập từ tiền lương, tiền công",
    label: "Thuế thu nhập từ tiền lương, tiền công",
  },
  {
    value: "Thuế thu nhập từ hoạt động sản xuất, kinh doanh cá nhân",
    label: "Thuế thu nhập từ hoạt động sản xuất, kinh doanh cá nhân",
  },
  {
    value: "Thuế thu nhập từ vốn đầu tư vốn cá nhân",
    label: "Thuế thu nhập từ vốn đầu tư vốn cá nhân",
  },
  {
    value: "Thuế thu nhập từ chuyển nhượng vốn (không bao gồm chuyển nhượng và chứng khoáng)",
    label: "Thuế thu nhập từ chuyển nhượng vốn (không bao gồm chuyển nhượng và chứng khoáng)",
  },
  {
    value:
      "Thuế thu nhập từ chuyển nhượng bất động sản nhận thừa kế và nhận quà tặng là bất động sản",
    label:
      "Thuế thu nhập từ chuyển nhượng bất động sản nhận thừa kế và nhận quà tặng là bất động sản",
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    contentSubmission: {
      type: "input",
      value: "",
      bg: true,
    },
    identifierID: {
      type: "input",
      value: "",
      bg: false,
    },
    chapter: {
      type: "input",
      value: "",
      bg: false,
    },
    part: {
      type: "select",
      value: "",
      bg: false,
      option: partOption,
    },
    taxAuthoritiesProvince: {
      type: "select",
      value: null,
      bg: true,
      option: taxAuthoritiesOption,
    },
    taxAuthoritiesDistrict: {
      type: "select",
      value: null,
      bg: true,
      option: taxAuthoritiesOption,
    },
    amountType: {
      type: "input",
      value: "VNĐ",
      bg: true,
    },
    amountMustPaid: {
      type: "input",
      value: 0,
      bg: false,
    },
    amountPaid: {
      type: "input",
      value: 0,
      bg: false,
    },
    overpaidAmount: {
      type: "input",
      value: 0,
      bg: true,
    },
  },
];

export default function RefundTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" flexDirection={"column"} justifyContent="flex-start">
        <Typography component="label" variant="caption" fontSize={14} fontWeight="bold" mb={0.5}>
          II - THÔNG TIN SỐ TIỀN THUẾ, TIỀN CHẬM NỘP, TIỀN PHẠT NỘP THỪA
        </Typography>
        <Typography variant="subtitle1" fontSize={13} fontStyle="normal">
          1. thông tin về khoản thu đề nghị hoàn trả
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Nội dung khoản nộp thừa
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Mã định danh khoản phải nộp (ID) (Nếu có)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Chương
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", width: "20%" }}>
                Tiểu mục
              </Td>
              <Td colSpan={2} style={{ textAlign: "center", width: "20%" }}>
                Tên cơ quan thu
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Loại tiền
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền phải nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền đã nộp vào NSNN
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền đã nộp thừa
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                QT cấp cục
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                QT cấp chi cục
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (5)
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                (6)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (7)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (8)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (9)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                {`(10)=(9)-(8)>0`}
              </Td>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "#fff",
                    }}
                  >
                    {index + 1}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.contentSubmission.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.contentSubmission?.type !== "input" ? (
                      row.contentSubmission.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="contentSubmission"
                        value={row.contentSubmission.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.identifierID.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.identifierID?.type !== "input" ? (
                      row.identifierID.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="identifierID"
                        value={row.identifierID.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.chapter.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.chapter?.type !== "input" ? (
                      row.chapter.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="chapter"
                        value={row.chapter.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.part.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.part?.type !== "select" ? (
                      row.part.value
                    ) : (
                      <SelectTable
                        name="part"
                        id={row.id.value}
                        option={row.part.option ? row.part.option : defaultOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.taxAuthoritiesProvince.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxAuthoritiesProvince?.type !== "select" ? (
                      row.taxAuthoritiesProvince.value
                    ) : (
                      <SelectTable
                        name="taxAuthoritiesProvince"
                        id={row.id.value}
                        option={
                          row.taxAuthoritiesProvince.option
                            ? row.taxAuthoritiesProvince.option
                            : defaultOption
                        }
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.taxAuthoritiesDistrict.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxAuthoritiesDistrict?.type !== "select" ? (
                      row.taxAuthoritiesDistrict.value
                    ) : (
                      <SelectTable
                        name="taxAuthoritiesDistrict"
                        id={row.id.value}
                        option={
                          row.taxAuthoritiesDistrict.option
                            ? row.taxAuthoritiesDistrict.option
                            : defaultOption
                        }
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.amountType.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.amountType?.type !== "input" ? (
                      row.amountType.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="amountType"
                        value={row.amountType.value}
                        onChange={handleChange}
                        style={{
                          background: "none",
                          fontSize: "13px",
                          textAlign: "center",
                          outLine: "none",
                          border: "none",
                        }}
                        readOnly={true}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.amountMustPaid.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.amountMustPaid?.type !== "input" ? (
                      row.amountMustPaid.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="amountMustPaid"
                        value={row.amountMustPaid.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.amountPaid.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.amountPaid?.type !== "input" ? (
                      row.amountPaid.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="amountPaid"
                        value={row.amountPaid.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.overpaidAmount.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.overpaidAmount?.type !== "input" ? (
                      row.overpaidAmount.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="overpaidAmount"
                        value={row.overpaidAmount.value}
                        onChange={handleChange}
                        readOnly={true}
                      />
                    )}
                  </Td>
                </tr>
              ))}

            <tr>
              <Td
                colspan="7"
                row={{ bold: true }}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng theo tiểu mục:
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
            <tr>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                1
              </Td>
              <Td
                colspan="6"
                row={{ bold: true }}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
            </tr>
            <tr>
              <Td
                colspan="7"
                row={{ bold: true }}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                {" "}
                Tổng cộng{" "}
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
